<template>
  <b-modal
    :title="'Elimininar Rol'"
    ref="modalEditionRol"
    hide-footer
    centered
  >
    <b-overlay :show="isSaving">
      <div class="row">
        <div class="col-md-12">
          Escriba el nombre del rol: <code>{{rol.name}}</code>
        </div>
        <div class="col-md-12 mt-2">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              id="nombre"
              v-model="confirmation"
              placeholder="Nombre del rol"
            >
          </div>
        </div>
        <div class="col-md-12">
          <button
            class="btn btn-primary"
            @click="deleteRol"
            :disabled="rol.name !== confirmation"
          >
            Eliminar
          </button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

import { ioDeleteCompanyRol } from '@/febos/servicios/api/empresas.api';

export default {
  name: 'RolDeleteModal',
  data() {
    return {
      isSaving: false,
      rol: {
        rolId: undefined,
        name: ''
      },
      confirmation: ''
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    isValid() {
      return !!(
        this.rol.name
      );
    }
  },
  methods: {
    async deleteRol() {
      this.isSaving = true;
      const { rol } = this;
      try {
        await ioDeleteCompanyRol(
          this.company.id,
          rol.rolId
        );
        this.$emit('deleteRol', this.rol);
        this.$refs.modalEditionRol.hide();
        this.isSaving = false;
      } catch (e) {
        console.error(e);
        this.isSaving = false;
      }
    },
    open(rol) {
      this.rol = {
        rolId: rol.rolId,
        name: rol.nombre
      };
      this.confirmation = '';
      this.$refs.modalEditionRol.show();
    },
    hide() {
      this.$refs.modalEditionRol.hide();
    }
  }
};
</script>

<style scoped>

</style>
